/* eslint-disable max-len */
import React from 'react';

import { Container, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    heading: {
      color: '#172B4D',
      fontSize: '30px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '26px',
      marginBottom: '2rem',
      textAlign: 'left',
    },
    subHeading: {
      color: '#172B4D',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '26px',
      marginBottom: '2rem',
      textAlign: 'left',
    },
    text: {
      color: '#172B4D',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '26px',
      marginBottom: '2rem',
      textAlign: 'left',
    },
    title: {
      color: '#172B4D',
      fontSize: '48px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '56px',
      marginBottom: '2rem',
      textAlign: 'left',
    },
  };
});

export default () => {
  const classes = useStyles();
  return (
    <Container className="pt-2 pb-2">
      <Typography className={classes.title}>Mediphany Terms of Service</Typography>
      <Typography className={classes.heading}>Imaging Educational Services</Typography>
      <Typography className={classes.text}>
        Mediphany receives medical images, imaging reports and other information from its users or from physicians, radiologists, or hospital systems (“Medical Providers”),
        regarding diagnostic imaging procedures and related services provided by Medical Providers to the user and prepares an educational video report to help the user understand
        the images and the imaging reports. WHILE MEDIPHANY’S IMAGING EDUCATIONAL CONSULTANTS MAY BE RADIOLOGISTS OR PHYSICIANS IN ADVANCED RADIOLOGY TRAINING, THEY ARE NOT ACTING
        AS MEDICAL PROVIDERS WHEN PROVIDING THE SERVICES AND DO NOT PROVIDE DIAGNOSTIC SERVICES, SECOND OPINIONS, MEDICAL ADVICE OR MEDICAL RECOMMENDATIONS IN CONNECTION WITH THE
        SERVICES. YOU ACKNOWLEDGE THAT YOU ARE NOT ENTERING INTO A PHYSICIAN-PATIENT OR ANY OTHER PRIVILEGED OR FIDUCIARY RELATIONSHIP WITH MEDIPHANY AND ITS IMAGING EDUCATIONAL
        CONSULTANTS, AND THAT MEDIPHANY AND ITS IMAGING EDUCATIONAL CONSULTANTS ARE NOT LIABLE FOR ANY ADVICE, MEDICAL CARE, IMAGING REPORTS, OR TREATMENT YOU RECEIVE FROM ANY
        MEDICAL PROVIDERS OR FOR ANY CONSEQUENCES, INJURY OR HARM THAT MAY RESULT THEREFROM. MEDIPHANY CREATES ITS EDUCATIONAL VIDEOS FROM THE IMAGES AND INFORMATION PROVIDED IN
        YOUR MEDICAL PROVIDER’S IMAGING REPORT AND IS NOT RESPONSIBLE FOR ANY FINDINGS IN THE REPORT. MEDIPHANY AND ITS IMAGING EDUCATIONAL CONSULTANTS DO NOT HAVE A DUTY TO
        ADVISE, DIAGNOSE, OR TREAT YOU, OR TO NOTIFY YOU OF ANY IRREGULARITIES OR INCORRECT FINDINGS IN THE REPORT OR FAILURE OF YOUR MEDICAL PROVIDER TO NOTE ANY SIGNIFICANT
        FINDINGS. IMAGING EDUCATIONAL CONSULTANTS MAY, BUT ARE NOT REQUIRED TO, SUGGEST THAT USERS HAVE THEIR MEDICAL PROVIDERS RE-REVIEW THE IMAGING REPORT IF THE IMAGE SHOWS
        ABNORMALITIES THAT ARE NOT ADDRESSED IN THE IMAGING REPORT.
      </Typography>
    </Container>
  );
};
